import { GetAccountAssetsResponse } from "@syla/shared/types/responses/GetAccountAssetsResponse";
import { useQuery } from "react-query";
import { UseQueryOptions } from "react-query/types/react/types";
import { getAccountAssets } from "../api/asset/getAccountAssets";
import { getAccountTransactionsCacheKey } from "./transactionsStore";

export const useQueryAccountAssets = <
  TQueryFnData = GetAccountAssetsResponse,
  TError = unknown,
  TData = TQueryFnData,
>(
  accountId: string,
  options?: Omit<
    UseQueryOptions<GetAccountAssetsResponse, TError, TData>,
    "queryKey" | "queryFn"
  >,
) => {
  return useQuery(
    [...getAccountTransactionsCacheKey(accountId), "assets"],
    () => getAccountAssets(accountId),
    options,
  );
};
